import { useEffect } from "react";
import "../styles/Contents.css";

export default function StayAndStudy() {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".reveal, .reveal-left, .reveal-right"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          } else {
            entry.target.classList.remove("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="page">
      {/* HERO */}
      <section className="about-hero reveal">
        <h1>Stay & Study</h1>
        <p>
          A complete residential academic ecosystem that blends disciplined living,
          expert guidance, and a distraction-free environment to help students achieve consistent excellence.
        </p>
      </section>

      {/* What is Stay & Study */}
      <section className="about-section reveal-right">
        <div className="about-row">
          <div className="about-content">
            <h2>What is Stay & Study?</h2>
            <ul>
              <li>24/7 residential facility with comfortable accommodation</li>
              <li>Nutritious, hygienic, home-style food</li>
              <li>Quality classroom teaching and guided self-study</li>
              <li>Faculty and mentors available throughout the day</li>
              <li>Ideal for students preparing for competitive exams and board success</li>
            </ul>
          </div>
          <img
            src="/images/study.jpg"
            alt="Study Environment"
            className="about-image"
          />
        </div>
      </section>

      {/* Integrated Learning Environment */}
      <section className="about-section reveal-left">
        <div className="about-row reverse">
          <div className="about-content">
            <h2>🏫 Integrated Learning Environment</h2>
            <p>
              Stay & Study at ACCESS offers students a structured residential setup
              where academics, discipline, and personal growth go hand in hand.
            </p>
            <ul>
              <li>Academics integrated with disciplined daily routines</li>
              <li>Dedicated study halls and classrooms</li>
              <li>Peaceful campus atmosphere</li>
              <li>Limited distractions for maximum concentration</li>
              <li>Learning culture that promotes consistency and self-discipline</li>
            </ul>
          </div>
          <img
            src="/images/study.jpg"
            alt="Study Environment"
            className="about-image"
          />
        </div>
      </section>

      {/* Daily Academic Discipline */}
      <section className="about-section reveal-right">
        <div className="about-row">
          <div className="about-content">
            <h2>📚 Daily Academic Discipline</h2>
            <p>
              Students follow a carefully planned daily schedule including classroom
              sessions, guided self-study hours, revisions, and tests.
            </p>
            <ul>
              <li>Classroom teaching with experienced faculty</li>
              <li>Guided self-study sessions</li>
              <li>Daily revisions and concept reinforcement</li>
              <li>Weekly tests and performance analysis</li>
              <li>Personalized academic tracking</li>
              <li>Time-management training</li>
            </ul>
          </div>
          <img
            src="/images/classroom.jpeg"
            alt="Classroom Learning"
            className="about-image"
            />
        </div>
      </section>

      {/* Safe & Comfortable Hostels */}
      <section className="about-section reveal-left">
        <div className="about-row reverse">
          <div className="about-content">
            <h2>🛏️ Safe & Comfortable Hostels</h2>
            <p>
              We provide secure and comfortable residential facilities that feel like a second home.
            </p>
            <ul>
              <li>Separate hostels for boys and girls</li>
              <li>Clean, well-ventilated rooms</li>
              <li>Strict safety and supervision standards</li>
              <li>Calm and disciplined residential atmosphere</li>
              <li>Comfortable beds and proper lighting for study</li>
            </ul>
          </div>
          <img
            src="/images/Hostel.jpg"
            alt="Hostel Facilities"
            className="about-image"
          />
        </div>
      </section>

      {/* Mentorship & Well-Being */}
      <section className="about-section reveal-right">
        <div className="about-row">
          <div className="about-content">
            <h2>🧠 Mentorship & Well-Being</h2>
            <ul>
              <li>Regular one-on-one mentoring sessions</li>
              <li>Continuous doubt-clearing support</li>
              <li>Emotional guidance and motivation</li>
              <li>Stress-management and confidence-building</li>
              <li>Friendly and approachable wardens & faculty</li>
            </ul>
          </div>
          <img
            src="/images/mentoring.jpg"
            alt="Mentoring Support"
            className="about-image"
          />
        </div>
      </section>

      {/* Healthy & Hygienic Food */}
      <section className="about-section reveal-left">
        <div className="about-row reverse">
          <div className="about-content">
            <h2>🍽️ Healthy & Hygienic Food</h2>
            <ul>
              <li>Freshly prepared vegetarian meals</li>
              <li>Balanced diet to improve focus and stamina</li>
              <li>Clean kitchen and dining areas</li>
              <li>Fixed meal timings to maintain discipline</li>
              <li>Special care for students’ health and hygiene</li>
              <li>Food quality monitored regularly</li>
            </ul>
          </div>
          <img
            src="/images/HostelFood.jpeg"
            alt="Healthy Food Facilities"
            className="about-image"
          />
        </div>
      </section>

      {/* Why Choose Stay & Study */}
      <section className="about-section reveal-right">
        <div className="about-row">
          <div className="about-content">
            <h2>🎯 Why Choose Stay & Study?</h2>
            <ul>
              <li>Structured and disciplined daily routine</li>
              <li>Continuous academic monitoring</li>
              <li>Distraction-free learning environment</li>
              <li>Experienced faculty and residential wardens</li>
              <li>Strong focus on consistency and results</li>
              <li>Perfect for competitive exam aspirants</li>
            </ul>
          </div>
          <img
            src="/images/Hostel2.jpeg"
            alt="Hostel Facilities"
            className="about-image"
          />
        </div>
      </section>

      {/* Stay Facilities */}
      <section className="about-section reveal-left">
          <div className="about-content">
            <h2>🏠 Stay Facilities</h2>
            <ul>
              <li>Clean and well-organized rooms</li>
              <li>Dedicated study halls</li>
              <li>Washing machine facilities</li>
              <li>Laundry and room-cleaning assistance</li>
              <li>Calm and peaceful surroundings</li>
              <li>24/7 hot water supply</li>
              <li>24/7 uninterrupted power supply</li>
              <li>Secure premises with supervision</li>
            </ul>
        </div>
      </section>

      {/* FOOTER */}
      <section className="about-footer reveal">
        <p>
          Stay & Study at ACCESS is more than just accommodation — it is a complete academic lifestyle designed to nurture discipline, confidence, and consistent academic excellence in a focused and supportive environment.
        </p>
      </section>
    </div>
  );
}
